const ACTIVE_CLASS = 'is-active';

export default function () {
    for (const button of document.querySelectorAll('.event-header__audio--inline')) {
        const audio = button.querySelector('audio');

        button.addEventListener('click', () => {
            if (audio.paused) {
                audio.play();
                button.classList.add(ACTIVE_CLASS);
            } else {
                audio.pause();
                button.classList.remove(ACTIVE_CLASS);
            }
        });

        audio.addEventListener('ended', () => {
            button.classList.remove(ACTIVE_CLASS);
        });
    }

    for (const popover of document.querySelectorAll('.event-header__audio--embed [popover]')) {
        const button = document.querySelector(`[popovertarget="${popover.id}"]`);

        popover.addEventListener('toggle', ({ newState }) => {
            if (newState === 'open') {
                button.setAttribute('aria-expanded', 'true');
                button.classList.add(ACTIVE_CLASS);
            } else {
                button.setAttribute('aria-expanded', 'false');
                button.classList.remove(ACTIVE_CLASS);
            }
        });
    }
}
